import { StringUnionKeyAsValue } from '../helpers/TypescriptHelpers';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IExplorableItemTypeInfo } from './resourceInfoParts';


/**
 * These are the item types that can be browsed in an Explorer.
 * Includes the "primary" content types (from the exploreContent API) and also non-content
 * entities that can be browsed (e.g. subscriptions, refresh extracts).
 */
export type ExplorableItemType = ExploreContentApi_ContentType
    | 'accelerationTask'
    | 'backgroundJob'
    | 'collection'
    | 'connectedApplication'
    | 'connectedWorkbook'
    | 'connection'
    | 'customView'
    | 'dataalert'
    | 'extractTask'
    | 'flowOutputStepRun'
    | 'group'
    | 'publishedConnectionTable'
    | 'publishedConnectionColumn'
    | 'recommendedView'
    | 'remoteRefreshSchedule'
    | 'resourceGovernanceSetting'
    | 'runFlowTask'
    | 'schedule'
    | 'searchuser' // Currently used to display user results in search
    | 'serveruser'
    | 'userIdentityConflict'
    | 'site'
    | 'siteuser'
    | 'subscription'
    | 'workbookAcceleration'
    | 'runFlowTask'
  ;

export const ExplorableItemTypeValue: StringUnionKeyAsValue<ExplorableItemType> = {
  accelerationTask: 'accelerationTask',
  backgroundJob: 'backgroundJob',
  collection: 'collection',
  connectedApplication: 'connectedApplication',
  connectedWorkbook: 'connectedWorkbook',
  connection: 'connection',
  customView: 'customView',
  dataalert: 'dataalert',
  database: 'database',
  databaseWithCrass: 'databaseWithCrass',
  dataconnection: 'dataconnection',
  dataRole: 'dataRole',
  datasource: 'datasource',
  extractTask: 'extractTask',
  flow: 'flow',
  flowOutputStepRun: 'flowOutputStepRun',
  group: 'group',
  lens: 'lens',
  metric: 'metric',
  project: 'project',
  publishedConnection: 'publishedConnection',
  publishedConnectionTable: 'publishedConnectionTable',
  publishedConnectionColumn: 'publishedConnectionColumn',
  recommendedView: 'recommendedView',
  remoteRefreshSchedule: 'remoteRefreshSchedule',
  resourceGovernanceSetting: 'resourceGovernanceSetting',
  runFlowTask: 'runFlowTask',
  schedule: 'schedule',
  searchuser: 'searchuser',
  serveruser: 'serveruser',
  userIdentityConflict: 'userIdentityConflict',
  site: 'site',
  siteuser: 'siteuser',
  subscription: 'subscription',
  table: 'table',
  tableWithCrass: 'tableWithCrass',
  view: 'view',
  workbook: 'workbook',
  workbookAcceleration: 'workbookAcceleration',
};

/**
 * These are the entity types that have their own landing pages ("space page").
 * These content types and explorable items, so their names should match where possible.
 */
export type SpaceInfoItemType = 'project' | 'schedule' | 'workbook' | 'view' | 'datasource' | 'flow'
  | 'dataRole' | 'lens' | 'group' | 'siteuser'| 'serveruser' | 'metric' | 'collection' | 'publishedConnection'
  | 'publishedConnectionTable' | 'resourceGovernanceSetting' | 'connectedApplication';

export const SpaceInfoItemTypeValue: StringUnionKeyAsValue<SpaceInfoItemType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  dataRole: 'dataRole',
  lens: 'lens',
  group: 'group',
  siteuser: 'siteuser',
  serveruser: 'serveruser',
  schedule: 'schedule',
  metric: 'metric',
  collection: 'collection',
  publishedConnection: 'publishedConnection',
  publishedConnectionTable: 'publishedConnectionTable',
  resourceGovernanceSetting: 'resourceGovernanceSetting',
  connectedApplication: 'connectedApplication',
};

export function isSpaceInfoItemType(itemType: string): itemType is SpaceInfoItemType {
  return SpaceInfoItemTypeValue.hasOwnProperty(itemType);
}

export function isRecommendationType(itemType: ExplorableItemType): itemType is ExplorableItemType {
  const recommendationTypes = ['recommendedView'];
  return itemType && recommendationTypes.includes(itemType);
}

export function mapRecTypeToBaseType(itemType: string): SpaceInfoItemType{
  if (itemType === 'recommendedView') {
    return 'view';
  }
}

export function getKeyForExplorableItem(item: IExplorableItemTypeInfo): string {
  return `${item.contentType}_${item.id}`;
}
